import { BaseModel } from "../base.model";

export class AuditActionGroup extends BaseModel {
  id: number;
  name: string;
  description: string;
}
